import React, { useEffect } from 'react';
import {  
  Paper,
  CircularProgress,
  IconButton,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { compose, } from 'recompose';
import { connect } from 'react-redux';
import { processingItemsService, fetchProcessingHomes } from 'store/actions';
import { DataGrid, Column, SearchPanel, Paging, Scrolling, Summary, TotalItem } from 'devextreme-react/data-grid';
import RefreshIcon from '@material-ui/icons/Refresh';
import { sendClientLog } from 'services/logService';

const ProcessingItemsTab = ({
  classes,
  processingItems,
  processingItemsService,
  fetchProcessingHomes,
  processingHomes,
  processingHomesIsLoading
}) => {
  useEffect(() => {
    sendClientLog('Info', 'Admin - User started processing items and opportunities data fetch');
    processingItemsService();
    fetchProcessingHomes();
  }, []);

  function handleRefreshPressed(){
    sendClientLog('Info', 'Admin - User started processing items and opportunities data fetch - refresh button');
    processingItemsService();
    fetchProcessingHomes();
  }

  return (
    <Paper id="processingItemsGridContainer" className={classes.tabContainer}>
      {
        (processingItems.loading || processingHomesIsLoading) &&
        <div className={classes.loading}><CircularProgress /></div>
      }
      {
        !processingItems.loading && !processingHomesIsLoading && !processingItems.data && !processingHomes.length &&
        <Typography variant='subtitle2'>No Items Available</Typography>
      }
      {
        !processingItems.loading && processingItems.data && processingItems.data.data && 
        <div className={classes.section}>
          <div id="divSummary">
            <Typography variant='subtitle1'>{
              processingItems.data.data.processingWorkflowTransactions.length +
              processingItems.data.data.pendingTransactions.length +
              processingItems.data.data.uncompletedImports.length +
              processingItems.data.data.queuedItems.length +
              processingHomes.length
            }</Typography>
            <Typography variant='subtitle2'>Processing Items</Typography>
          </div>
          <IconButton id="btnRefreshProcItems" onClick={handleRefreshPressed} className={classes.refreshButton}>
            <RefreshIcon />
          </IconButton>
        </div>
      }
      {
        processingItems.data && processingItems.data.data && processingItems.data.data.processingWorkflowTransactions.length > 0 && !processingItems.loading &&
        <div className={classes.section}>
          <Typography variant='subtitle1'>Processing Opportunities</Typography>
          <DataGrid dataSource={processingItems.data.data.processingWorkflowTransactions} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true} allowColumnResizing={true}>
            <Column dataField='type' caption='Type' width="auto" />
            <Column dataField='id' caption='Id' width="auto" />
            <Column dataField='allocationStartedOn' caption='Allocation Started On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='allocationFinishedOn' caption='Allocation Finished On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='autopricingStartedOn' caption='Autopricing Started On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='autopricingFinishedOn' caption='Autopricing Finished On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='prismSubmissionStartedOn' caption='PRISM Submission Started On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='prismSubmissionFinishedOn' caption='PRISM Submission Finished On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='reloadStartedOn' caption='Reload Started On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='reloadFinishedOn' caption='Reload Finished On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
          </DataGrid>
        </div>
      }
      {
        processingItems.data && processingItems.data.data && processingItems.data.data.pendingTransactions.length > 0 && !processingItems.loading &&
        <div className={classes.section}>
          <Typography variant='subtitle1'>Pending Bid Submissions</Typography>
          <DataGrid dataSource={processingItems.data.data.pendingTransactions} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true} allowColumnResizing={true}>
            <Column dataField='id' caption='Id' width="auto" />
          </DataGrid>
        </div>
      }
      {
        processingItems.data && processingItems.data.data && processingItems.data.data.uncompletedImports.length > 0 && !processingItems.loading &&
        <div className={classes.section}>
          <Typography variant='subtitle1'>Imports In Progress</Typography>
          <DataGrid dataSource={processingItems.data.data.uncompletedImports} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true} allowColumnResizing={true}>
            <Column dataField='channelStr' caption='Channel' width="auto" />
            <Column dataField='name' caption='Name' width="auto" />
            <Column dataField='importedBy' caption='Created By' width="auto" />
            <Column dataField='createdOn' caption='Imported On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='importCount' caption='Opportunities' width="auto" />
            <Column dataField='sender' caption='From' width="auto" />
            <Column dataField='id' caption='Import ID' width="auto" />
          </DataGrid>
        </div>
      }
      {
        processingItems.data && processingItems.data.data && processingItems.data.data.queuedItems.length > 0 && !processingItems.loading &&
        <div className={classes.section}>
          <Typography variant='subtitle1'>Internal Queue</Typography>
          <DataGrid dataSource={processingItems.data.data.queuedItems} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true} allowColumnResizing={true}>
            <Column dataField='serviceWorkerQueueType' caption='Queue Type' width="auto" />
            <Column dataField='queueStatus' caption='Queue Status' width="auto" />
            <Column dataField='createdOn' caption='Created On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='lastUpdatedOn' caption='Last Updated On' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
          </DataGrid>
        </div>
      }
      {
        processingHomes.length > 0 && !processingHomesIsLoading &&
        <div className={classes.section}>
          <Typography variant='subtitle1'>Processing Homes</Typography>
          <DataGrid dataSource={processingHomes} showRowLines={true} showColumnLines={true} showBorders={true} columnAutoWidth={true} allowColumnResizing={true}>
            <SearchPanel visible={true} searchVisibleColumnsOnly={true} />
            <Paging defaultPageSize={20} />
            <Scrolling
              rowRenderingMode='virtual'
            />
            <Column dataField='id' width="auto" />
            <Column dataField='createdOn' dataType={"date"} format={"MM/dd/yyyy h:mm a"} width="auto" />
            <Column dataField='asgPropID' caption='asgPropID' width="auto" />
            <Column dataField='importId' width="auto" />
            <Summary>
              <TotalItem
                column={'id'}
                summaryType={'count'} />
            </Summary>
          </DataGrid>
        </div>
      }
    </Paper>
  );
};

const styles = theme => ({
  content: {
    padding: 'initial',
    alignItems: 'center',
    minHeight: 200,
    width: '100%'
  },
  section: {
    width: '100%',
    marginBottom: '35px',
    "& #divSummary": {
      color: '#fff',
      width: '130px',
      display: 'inline-flex',
      flexFlow: 'column',
      background: '#80a4c7',
      textAlign: 'center',
      justifyContent: 'center'
    },
    "& #btnRefreshProcItems": {
      marginLeft: '15px',
      marginTop: '15px'
    },
  },
  tabContainer: {
      padding: '30px',
      height: '100%'
  },
  loading: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  }
});

const mapStateToProps = ({ adminState }) => ({
  processingItems: adminState.processingItems,
  processingHomes: adminState.processingHomes,
  processingHomesIsLoading: adminState.processingHomesIsLoading
});

const mapDispatchToProps = {
  processingItemsService,
  fetchProcessingHomes
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ProcessingItemsTab);